import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import $ from "jquery"
import "popper.js"
import React, { Component } from "react"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import EventBus from "../common/EventBus.js"
import GlobalHelper from "../common/GlobalHelper.jsx"
import ActionButton from "../common/button/actionbutton.component.jsx"
import ConfirmButton from "../common/button/confirmbutton.component.jsx"
import SendEmailModal from "../common/email/sendemail.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import InlineDateEditComponent from "../common/inline-edit/component/InlineDateEditComponent"
import InlineEditContact from "../common/inline-edit/contact.component.jsx"
import InlineEditImage from "../common/inline-edit/image.component.jsx"
import InlineEditLocation from "../common/inline-edit/location.component.jsx"
import InlineEditTemplate from "../common/inline-edit/template.component.jsx"
import InlineEditText from "../common/inline-edit/text.component.jsx"
import InlineEditUser from "../common/inline-edit/user.component.jsx"
import SideBar from "../common/layout/sidebar.component.jsx"
import AddPricingRow from "../common/pricing/addItem.component.jsx"
import PricingTableTotals from "../common/pricing/totals.component.jsx"
import ProposalPreviewModal from "../common/proposal/previewmodal.component.jsx"
import QuoteCurrency from "../common/quote/currency.component.jsx"
import QuoteIdentifier from "../common/quote/identifier.component.jsx"
import LoadingSpinner from "../common/spinner/loading.component.jsx"
import { getPriceListName } from "../name-helpers/priceListNameHelper"
import PricingTableContent from "../pricing/PricingTableContentComponent.jsx"
import { generateOptions } from "../quote/utils/QuoteStatusOrderForm.ts"
import { fetchPriceLevels } from "../state/price-level/PriceLevelActions"
import { fetchPriceList, patchPriceList } from "../state/price-list/priceListActions"
import { getPriceList } from "../state/price-list/priceListSelectors"
import {
    setPricingTableGroupItems,
    setPricingTableGroups,
    setPricingTableInitialState,
    setPricingTableItems
} from "../state/pricing/actions"
import { PROPOSAL_TYPE } from "../state/proposal/ProposalType.ts"
import { EMAIL_TEMPLATE } from "../state/template/TemplateType"
import PriceListAnalytics from "./analytics.component.jsx"
import CustomerTagSelectComponent from "./components/CustomerTagSelectComponent"
import CustomerTypeSelectComponent from "./components/CustomerTypeSelectComponent"
import EmailNotificationToggle from "./components/EmailNotificationToggle.tsx"
import PriceListValidatorSelectComponent from "./components/PriceListValidatorSelectComponent"
import QuoteStatusSelectComponent from "./components/QuoteStatusSelectComponent.tsx"
import SyncItemsWithCatalogPrices from "./components/SyncItemsWithCatalogPrices"

const queryString = require("query-string")

const messages = defineMessages({
    group_default_name: {
        id: "invoice.edit.group.group_default_name",
        defaultMessage: "Unnamed group"
    }
})

class PriceListEdit extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            status: "",
            docGeneratedStatus: "",
            createdAt: null,
            redirect: "",
            sellerName: "",
            sellerId: "",
            depositAmount: "0",
            depositRatio: 0,
            items: [],
            groups: [],
            emails: [],
            templates: [],
            priceList: null,
            proposal: null,
            title: "",
            templateId: "",
            numberOfOrders: 0,
            amountOfOrders: "",
            currency: "",
            documentLink: "",
            identifierId: "",
            addItemModal: "",
            identifier: "",
            exchangeRate: "",
            shareTitle: "",
            shareDescription: "",
            shareImageId: "",
            objectType: "invoice",
            deletedAt: "",
            hash: "",
            depositType: "",
            priceListId: "",
            loading: true,
            editable: true,
            editMode: false,
            emailSubject: "",
            emailContent: "",
            emailButtonLabel: "",
            fromEmailAddress: "",
            fromName: "",
            newOrderEmailTemplate: null,
            allowEdit: true,
            sendNotification: false,
            labelId: "",
            options: generateOptions(props.intl),
            syncItemsWithCatalogPrices: false
        }
        this.deletePriceList = this.deletePriceList.bind(this)
        this.setGlobalStateInitialValues = this.setGlobalStateInitialValues.bind(this)
        this.addGroup = this.addGroup.bind(this)
        this.review = this.review.bind(this)
        this.refreshPriceList = this.refreshPriceList.bind(this)
        this.sendNotification = this.sendNotification.bind(this)
        this.handleRefresh = this.handleRefresh.bind(this)
        this.handleEdit = this.handleEdit.bind(this)
        this.closeEditMode = this.closeEditMode.bind(this)
        this.openEditItemModal = this.openEditItemModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.handleAddItemModal = this.handleAddItemModal.bind(this)
        this.handleAddProductLink = this.handleAddProductLink.bind(this)
        this.markAsInactive = this.markAsInactive.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.saveEmail = this.saveEmail.bind(this)
        this.configureEmail = this.configureEmail.bind(this)
        this.markAsActive = this.markAsActive.bind(this)
        this.handleSyncItemsWithCatalogPrices = this.handleSyncItemsWithCatalogPrices.bind(this)
    }

    componentDidMount() {
        this.props.setPricingTableInitialState()
        this.props.fetchPriceList(this.props.match.params.priceListId)
        const uri = queryString.parse(this.props.location.search)
        this.setState({
            editMode: uri.em === "1"
        })
        AppContext.getApiClient()
            .get("/templates/" + EMAIL_TEMPLATE.TYPE_EMAIL_PRICE_LIST + "/template")
            .then(t => {
                this.setState({
                    newOrderEmailTemplate: t
                })
            })

        SideBar.activateMenu("pricelist")
    }

    refreshPriceList(value) {
        let listId = ""
        if (value && typeof value === "string") {
            listId = value
        }
        if (listId && listId !== this.state.priceListId) {
            window.scrollTo(0, 0)
        }
        if (!listId) {
            listId = this.state.priceListId
        }
        this.props.fetchPriceList(listId)
    }

    componentWillReceiveProps(props) {
        if (props && props.priceList) {
            const list = props.priceList.dto
            if (this.state.identifier !== list.attributes.identifier || this.state.status !== list.attributes.status) {
                EventBus.dispatch(EventBus.TopicUrlPathChange, {
                    path: "/price-lists/" + list.id + "/edit"
                })
                EventBus.dispatch(EventBus.TopicRefreshCurrentBreadcrumb, {
                    path: "/price-lists/" + list.id + "/edit"
                })
            }
            if (!["draft"].includes(list.attributes.status) && list.attributes.proposalHash) {
                AppContext.getApiClient()
                    .get("/proposals/" + list.attributes.proposalHash)
                    .then(res => {
                        if (!res.error) {
                            this.loadProposal(res)
                        }
                    })
            }

            this.setState({
                loading: false,
                priceList: list,
                priceListId: list.id,
                deletedAt: list.attributes.deletedAt,
                objectType: list.attributes.objectType,
                identifierId: list.attributes.identifierId,
                identifier: list.attributes.identifier,
                status: list.attributes.status,
                docGeneratedStatus: list.attributes.docGeneratedStatus,
                groups: list.attributes.groups,
                currency: list.attributes.currency,
                sendNotification: !list.attributes.notificationDisabled,
                emailSubject: list.attributes.emailSubject || "",
                emailContent: list.attributes.emailContent || "",
                emailButtonLabel: list.attributes.emailButtonLabel || "",
                fromEmailAddress: list.attributes.fromEmailAddress || "",
                fromName:list.attributes.emailFromName || "",
                title: list.attributes.title,
                templateId: list.attributes.templateId,
                numberOfOrders: list.attributes.numberOfOrders,
                amountOfOrders: list.attributes.amountOfOrders,
                exchangeRate: list.attributes.exchangeRate,
                items: list.attributes.items,
                totals: list.attributes.totals,
                shareTitle: list.attributes.shareTitle,
                shareDescription: list.attributes.shareDescription,
                shareImageId: list.attributes.shareImageId,
                shareImage: list.attributes.shareImage,
                depositAmount: list.attributes.depositAmount,
                depositType: list.attributes.depositType,
                depositRatio: list.attributes.depositRatio,
                createdAt: list.attributes.createdAt,
                activatedAt: list.attributes.activatedAt,
                sellerName: list.attributes.seller.attributes.firstName + " " + list.attributes.seller.attributes.lastName,
                locationName: list.attributes.location ? list.attributes.location.attributes.name : "",
                locationId: list.attributes.locationId,
                sellerId: list.attributes.seller.id,
                syncItemsWithCatalogPrices: list.attributes.syncItemsWithCatalogPrices,
            },
            () => this.setGlobalStateInitialValues())
        }
    }

    loadProposal(proposal) {
        if (proposal && proposal.attributes) {
            this.setState({
                proposal: proposal,
                hash: proposal.attributes.hash,
                pdfUri: proposal.attributes.variables.document.pdfUri,
                publicLink: proposal.attributes.publicLink
            })
        } else {
            this.setState({
                proposal: null
            })
        }
    }

    deletePriceList(event) {
        event.preventDefault()
        AppContext.getApiClient()
            .delete("/price-lists/" + this.state.priceListId, {})
            .then(res => {
                this.refreshPriceList()
            })
    }

    addGroup(event) {
        event.preventDefault()
        let groupId = ""
        return AppContext.getApiClient()
            .post("/price-lists/" + this.state.priceListId + "/groups", {
                name: this.props.intl.formatMessage(messages["group_default_name"]),
                rank: this.state.groups.length
            })
            .then(g => {
                groupId = g.id
                return AppContext.getApiClient().get("/price-lists/" + this.state.priceListId)
            })
            .then(res => {
                this.setState({ groups: res.attributes.groups }, () => {
                    this.props.setPricingTableGroups(this.state.groups, this.state.priceListId)
                    $([document.documentElement, document.body]).animate(
                        {
                            scrollTop: $("#sortable-quote-group-" + groupId)?.offset()?.top - 100
                        },
                        500
                    )
                })
            })
    }

    openEditItemModal(itemId, productId) {
        this.setState({
            modal: (
                <AddPricingRow
                    mainObject={"price-lists"}
                    mainObjectItem={"price-list-items"}
                    objectId={this.state.priceListId}
                    objectIdentifier={this.state.identifier}
                    onClose={this.handleCloseModal}
                    itemId={itemId}
                    productId={productId}
                    currency={this.state.currency}
                    exchangeRate={this.state.exchangeRate}
                    onItemAdd={this.handleAddItemModal}
                    forceBillingMethod={"one-time"}
                    location={this.state.priceList.attributes.location}
                />
            )
        })
    }

    handleAddProductLink(e) {
        e.preventDefault()
        this.openEditItemModal()
    }

    handleAddItemModal(keepOpen) {
        this.refreshPriceList()
        if (keepOpen) {
            return
        }
        this.setState({
            modal: ""
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ""
        })
    }

    renderItems() {
        return (
            <PricingTableContent
                mainObject={"price-lists"}
                mainObjectItem={"price-list-items"}
                tableId={this.state.priceList.attributes.pricingTableId}
                objectId={this.state.priceListId}
                onUpdate={() => {
                    this.refreshPriceList()
                }}
                currency={this.state.currency}
                allowEdit={!this.state.exportedToLightspeed || AppContext.getUserLoggedIn().attributes.superUser}
                sortable={true}
                onEditLinkClick={this.openEditItemModal}
                syncItemsWithCatalogPrices={this.state.syncItemsWithCatalogPrices}
            />
        )
    }

    createProposal() {
        if (this.state.proposal) {
            return Promise.resolve(this.state.proposal)
        }
        return AppContext.getApiClient().post("/proposals", {
            priceListId: this.state.priceListId,
            hash: this.state.priceList.attributes.proposalHash
        })
    }

    review(event) {
        event.preventDefault()
        const uri = this.state.editMode ? "?em=1" : ""
        this.createProposal().then(res => {
            this.setState({
                redirect: <Redirect to={"/proposals/" + res.attributes.hash + "/preview" + uri} />
            })
        })
    }

    sendNotification(notificationEnabled) {
        AppContext.getApiClient()
            .patch("/price-lists/" + this.state.priceListId, { notificationDisabled: !notificationEnabled })
            .then(res => {
                if (res.id) {
                    this.setState({ sendNotification: !res.attributes.notificationDisabled })
                }
            })
    }

    handleRefresh(value) {
        this.refreshPriceList(value)
    }

    handleEdit(invoiceId) {
        this.setState({
            editMode: true
        })
        window.scrollTo(0, 0)
    }

    closeEditMode(e) {
        e.preventDefault()
        this.refreshPriceList()
        this.setState({
            editMode: false
        })
        window.scrollTo(0, 0)
    }

    saveEmail(
        subject,
        toEmail,
        ccEmail,
        content,
        buttonLabel,
        pdfIncluded,
        templateId,
        fromEmailAddress,
        bccEmail,
        fromName,
        next
    ) {
        window.scrollTo( 0, 0 )
        const fromEmail=fromEmailAddress && fromEmailAddress.length>0?fromEmailAddress[0]:""
        this.setState({ loading: true })
        let data = {
            emailSubject: subject,
            emailContent: content,
            emailButtonLabel: buttonLabel,
            bccEmailAddress : bccEmail,
            fromEmailAddress: fromEmail,
            emailFromName: fromName
        }
        this.createProposal().then(res => {
            AppContext.getApiClient()
                .patch("/price-lists/" + this.state.priceListId, data)
                .then(res => {
                    if (res.id) {
                        if (next) {
                            next()
                        } else {
                            this.refreshPriceList(res.id)
                        }
                    } else {
                        this.setState({ loading: false })
                    }
                })
        })
    }

    markAsInactive(e) {
        e.preventDefault()
        AppContext.getApiClient()
        .post("/price-lists/" + this.state.priceListId + "/deactivate", {})
        .then(res => {
                        if (res.id) {
                            this.refreshPriceList(res.id)
                        } else {
                            this.setState({ loading: false })
                        }
                    })
        }



    markAsActive(e) {
        e.preventDefault()
        AppContext.getApiClient()
            .post("/price-lists/" + this.state.priceListId + "/activate", {})
                .then(res => {
                        if (res.id) {
                            this.refreshPriceList(res.id)
                        } else {
                            this.setState({ loading: false })
                        }
                            })
                    }

    configureEmail(event) {
        event.preventDefault()
        this.setState({
            modal: (
                <SendEmailModal
                    fromEmail={[this.state.fromEmailAddress]}
                    noToEmail={true}
                    noCcEmail={true}
                    lastEmailSubject={this.state.emailSubject}
                    lastEmailContent={this.state.emailContent}
                    bccEmail={this.state.bccEmail}
                    lastEmailButtonLabel={ this.state.emailButtonLabel }
                    title={<FormattedMessage id="price_list.send_email.modal.title" defaultMessage="Configure new order email" />}
                    isCustomFromName={this.state.fromName !== "" || this.state.sellerName !== ""}
                    fromName={ this.state.fromName || this.state.sellerName }
                    onSubmit={this.saveEmail}
                    onClose={this.handleCloseModal}
                    proposalType={"price-list"}
                    templateKey={"new-order-from-price-list"}
                    isRecurringEmail={true}
                    ctaLabel={<FormattedMessage id="common.send_email.modal.save_btn" defaultMessage="Save" />}
                />
            )
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ""
        })
    }

    setGlobalStateInitialValues() {
        this.props.fetchPriceLevels()
        this.props.setPricingTableItems(
            this.state.items,
            this.state.priceList.id,
            this.state.totals,
            this.state.priceList.attributes.pricingTableId
        )
        this.props.setPricingTableGroups(this.state.groups, this.state.priceList.id)
        this.props.setPricingTableGroupItems(this.state.groups, this.state.items, this.state.priceList.id)
    }

    openPreview(event) {
        event.preventDefault()
        this.createProposal().then(res => {
            this.setState({
                modal: (
                    <ProposalPreviewModal
                        onClose={this.handleCloseModal}
                        pdfLink={res.attributes.variables.document.pdfUri}
                        hash={res.attributes.hash}
                        publicLink={res.attributes.publicLink}
                        proposalType={"price-list"}
                    />
                )
            })
        })
    }

    getTemplateLabelByObjectType() {
        switch (this.state.objectType) {
            case "quote":
                return <FormattedMessage id="price_list.edit.details.quote_template_label" defaultMessage="Quote template" />
            case "invoice":
                return <FormattedMessage id="price_list.edit.details.invoice_template_label" defaultMessage="Invoice template" />
            case "credit-memo":
                return (
                    <FormattedMessage
                        id="price_list.edit.details.credit_memo_template_label"
                        defaultMessage="Credit memo template"
                    />
                )
        }
    }

    getTemplateTypeByObjectType() {
        switch (this.state.objectType) {
            case "quote":
                return "quote-template"
            case "invoice":
                return "invoice-template"
            case "credit-memo":
                return "credit-memo-template"
        }
    }

    handleSyncItemsWithCatalogPrices(event, actionId) {
        const syncItemsWithCatalogPrices = event.target.checked
        this.props.patchPriceList(this.state.priceListId, { syncItemsWithCatalogPrices }, actionId)
        this.setState({ syncItemsWithCatalogPrices })
    }

    render() {

        if (this.state.loading) {
            return <LoadingSpinner className="py-2" />
        }

        if (["active", "inactive", "completed"].includes(this.state.status) && !this.state.editMode) {
            return (
                <PriceListAnalytics
                    priceList={this.state.priceList}
                    proposal={this.state.proposal}
                    onRefresh={this.handleRefresh}
                    onEdit={this.handleEdit}
                />
            )
        }
        const priceList = this.props.priceList // as PriceList
        const firstCol = []
        const secondCol = []
        firstCol.push(
            <div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage id="price_list.edit.details.title_label" defaultMessage="Title" />
                </label>
                <div className="col-12">
                    <InlineEditText
                        editable={true}
                        endPoint={"/price-lists/" + this.state.priceListId}
                        field={"title"}
                        value={this.state.title}
                    />
                </div>
            </div>
        )

        firstCol.push(
            <div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label">{this.getTemplateLabelByObjectType()}</label>
                <div className="col-12">
                    <InlineEditTemplate
                        editable={true}
                        endPoint={"/price-lists/" + this.state.priceListId}
                        field={"templateId"}
                        templateType={this.getTemplateTypeByObjectType()}
                        value={this.state.templateId}
                    />
                </div>
            </div>
        )

        // Allow users to edit status if it's a quote
        if (priceList.getObjectType() == PROPOSAL_TYPE.QUOTE) {
            firstCol.push(
                <div key={firstCol.length} className="form-group row mb-0">
                    <QuoteStatusSelectComponent
                        docGeneratedStatus={priceList.getDocGeneratedStatus()}
                        onStatusChange={(value, actionId) =>
                            this.props.patchPriceList(priceList.getId(), { docGeneratedStatus: value }, actionId)
                        }
                        options={this.state.options}
                    />
                </div>
            )
        }

        firstCol.push(
            <div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage id="price_list.edit.details.sharing_title_label" defaultMessage="Sharing title" />
                </label>
                <div className="col-12">
                    <InlineEditText
                        editable={true}
                        endPoint={"/price-lists/" + this.state.priceListId}
                        field={"shareTitle"}
                        value={this.state.shareTitle}
                    />
                </div>
            </div>
        )

        firstCol.push(
            <div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage id="price_list.edit.details.sharing_image_label" defaultMessage="Sharing image" />
                </label>
                <div className="col-12">
                    <InlineEditImage
                        editable={true}
                        endPoint={"/price-lists/" + this.state.priceListId}
                        field={"shareImageId"}
                        imageField={"shareImage"}
                        value={this.state.shareImage}
                    />
                </div>
            </div>
        )

        firstCol.push(
            <div className="form-group row p-0 mb-0">
                <PriceListValidatorSelectComponent priceListId={priceList.getId()} />
            </div>
        )

        firstCol.push(
            <SyncItemsWithCatalogPrices
                key={firstCol.length}
                syncItemsWithCatalogPrices={this.state.syncItemsWithCatalogPrices}
                onChange={this.handleSyncItemsWithCatalogPrices}
            />
        )

        firstCol.push(
            <EmailNotificationToggle
                sendNotification={this.state.sendNotification}
                onChangeCallback={this.sendNotification}
                configureEmail={this.configureEmail}
            ></EmailNotificationToggle>
        )

        secondCol.push(
            <div key={secondCol.length} className="row">
                <div className="form-group row px-3 mb-0">
                    <label className="col-12 col-form-label custom-form-label" htmlFor="seller">
                        <FormattedMessage id="price_list.edit.details.assigned_to_label" defaultMessage="Assigned to" />
                    </label>
                    <div className="col-12">
                        <InlineEditUser
                            editable={true}
                            endPoint={"/price-lists/" + this.state.priceListId}
                            field={"sellerId"}
                            value={this.state.sellerName}
                            userId={this.state.sellerId}
                        />
                    </div>
                </div>
            </div>
        )

        secondCol.push(
            <div key={secondCol.length} className="row">
                <div className="form-group row px-3 mb-0">
                    <label className="col-12 col-form-label custom-form-label" htmlFor="location">
                        <FormattedMessage id="price_list.edit.details.location_label" defaultMessage="Location" />
                    </label>
                    <div className="col-12">
                        <InlineEditLocation
                            editable={GlobalHelper.canEditLocation()}
                            endPoint={"/price-lists/" + this.state.priceListId}
                            value={this.state.locationName}
                            locationId={this.state.locationId}
                        />
                    </div>
                </div>
            </div>
        )

        if (this.state.priceList.attributes.objectType === "credit-memo") {
            secondCol.push(
                <div key={secondCol.length} className="row">
                    <div className="form-group row px-3 mb-0">
                        <label className="col-12 col-form-label custom-form-label" htmlFor="location">
                            <FormattedMessage
                                id="price_list.edit.details.credit_memo_receiver_label"
                                defaultMessage="Credit memo receiver"
                            />
                        </label>
                        <div className="col-12">
                            <InlineEditContact
                                formClassName={"top-inherit"}
                                contactType={"persons"}
                                value={this.state.priceList.attributes.creditMemoContactReceiverId}
                                editable={this.state.numberOfOrders === 0}
                                endPoint={"/price-lists/" + this.state.priceListId}
                                field={"creditMemoContactReceiverId"}
                            />
                        </div>
                    </div>
                </div>
            )
        }

        secondCol.push(
            <div key={secondCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage
                        id="price_list.edit.details.sharing_description_label"
                        defaultMessage="Sharing description"
                    />
                </label>
                <div className="col-12">
                    <InlineEditText
                        editable={true}
                        multiLine={true}
                        endPoint={"/price-lists/" + this.state.priceListId}
                        field={"shareDescription"}
                        value={this.state.shareDescription}
                    />
                </div>
            </div>
        )

        secondCol.push(
            <div className="form-group p-0 row mb-0 col-6">
                <div className="col-12 col-form-label custom-form-label">
                    <FormattedMessage id="quote.analytics.expiration_date_label" defaultMessage="Expiration date" />
                </div>
                <div className="col-12">
                    <InlineDateEditComponent
                        id={"price-list-expiration-date-edit"}
                        value={priceList.getExpirationDate() || ""}
                        onSave={(value, actionId) =>
                            this.props.patchPriceList(priceList.getId(), { expirationDate: value }, actionId)
                        }
                    />
                </div>
            </div>
        )

        secondCol.push(
            <div key={secondCol.length} className="form-group row mb-0">
                <CustomerTypeSelectComponent
                    customerType={priceList.getCustomerType()}
                    onCustomerTypeChange={(type, actionId) =>
                        this.props.patchPriceList(priceList.getId(), { customerType: type }, actionId)
                    }
                />
            </div>
        )

        secondCol.push(
            <div key={secondCol.length} className="form-group row mb-0">
                <CustomerTagSelectComponent
                    customerTags={priceList.getCustomerTags()}
                    onCustomerTagsChange={(tag, actionId) =>
                        this.props.patchPriceList(priceList.getId(), { customerTags: tag }, actionId)
                    }
                />
            </div>
        )

        const actions = []
        if (["active", "inactive"].includes(this.state.status)) {
            actions.push(
                <button key={actions.length} className="btn btn-outline-secondary mb-2 mr-2" onClick={this.closeEditMode}>
                    <Icon value={"times"} className={"mr-1"} />
                    <FormattedMessage id="invoice.edit.close_edit_btn" defaultMessage="Close edit mode" />
                </button>
            )
        }

        if (this.state.items.length > 0) {
            actions.push(
                <ActionButton key={actions.length} className="btn btn-outline-primary mb-2 mr-2" onClick={this.review}>
                    <Icon value={"pencil-ruler"} className={"mr-1"} />
                    <FormattedMessage id="price_list.edit.edit_design_btn" defaultMessage="Edit design" />
                </ActionButton>
            )

            if (this.state.status === "draft") {
                actions.push(
                    <ActionButton
                        key={actions.length}
                        className="btn btn-outline-primary mr-2 mb-2"
                        onClick={this.markAsInactive}
                    >
                        <Icon value={"toggle-off"} className={"mr-1"} />
                        <FormattedMessage id="price_list.edit.preview.mark_as_inactive_btn" defaultMessage="Mark as inactive" />
                    </ActionButton>
                )

                actions.push(
                    <ActionButton key={actions.length} className="btn btn-success mb-2" onClick={this.markAsActive}>
                        <Icon value={"check"} className={"mr-1"} />
                        <FormattedMessage id="quote.edit.preview.activate_btn" defaultMessage="Activate" />
                    </ActionButton>
                )
            }
        }

        return (
            <div>
                <div className="row mb-5">
                    <div className="col-12">
                        {this.state.redirect}
                        {this.state.modal}
                        <div className="row px-3">
                            <div className="col-12">
                                <h4 className={"custom-lead"}>
                                    <FormattedMessage id="price_list.edit.details.title" defaultMessage="Details" />
                                </h4>
                            </div>
                        </div>
                        <div className="row m-0 px-3">
                            <div className="col-12 ui-module">
                                <div className="row justify-content-end">
                                    <div className="col-sm-12 col-md-6">
                                        <div className="row">
                                            <div className="col-12">{firstCol}</div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6">{secondCol}</div>
                                </div>
                            </div>
                        </div>

                        <div className="row px-3">
                            <div className="col-12 d-flex justify-content-between">
                                <h4 className={"custom-lead"}>
                                    <FormattedMessage id="invoice.edit.items.items_title" defaultMessage="Items" />
                                </h4>
                            </div>
                        </div>
                        <div className="m-0 px-3">
                            <div className={"ui-module pt-0"}>
                                {this.renderItems(this.state.items)}
                                {this.state.editable ? (
                                    <div className="col-12 quote-add-product" onClick={this.handleAddProductLink}>
                                        <a href="#" className="btn btn-link btn-add-product">
                                            <FormattedMessage id="invoice.edit.add_product_btn" defaultMessage="Add a product" />
                                        </a>
                                    </div>
                                ) : (
                                    ""
                                )}
                                <div className={"row mb-3"}>
                                    <div className={"col-md-4"}>
                                        <div className={"mt-4 pt-2 mb-0 w-100"}>
                                            <button className={"btn btn-outline-primary"} onClick={this.addGroup}>
                                                <Icon value={"layer-group"} className={"mr-1"} />
                                                <FormattedMessage id="invoice.edit.add_group_btn" defaultMessage="Add a group" />
                                            </button>
                                        </div>
                                        {GlobalHelper.getEnabledCurrenciesSelectOptions().length > 1 ? (
                                            <div className={"pt-3 w-100"}>
                                                <QuoteCurrency
                                                    className={"mr-2 w-100"}
                                                    mainObject={"price-lists"}
                                                    objectId={this.state.priceListId}
                                                    editable={true}
                                                    currency={this.state.currency}
                                                    onChange={this.refreshPriceList}
                                                />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <div className={"pt-3 w-100"}>
                                            <QuoteIdentifier
                                                className={"mr-2 w-100"}
                                                identifierId={this.state.identifierId}
                                                identifier={this.state.identifier}
                                                editable={true}
                                                onChange={this.refreshPriceList}
                                            />
                                        </div>
                                    </div>
                                    <div className={"col-md-8 pb-3"}>
                                        <PricingTableTotals
                                            totalClassName={"col-lg-8 col-md-12"}
                                            allowEdit={this.state.allowEdit}
                                            rows={this.state.items}
                                            mainObjectId={this.state.priceListId}
                                            mainObject={"price-lists"}
                                            objectId={this.state.priceListId}
                                            onChange={this.refreshPriceList}
                                            depositType={this.state.depositType}
                                            depositAmount={this.state.depositAmount}
                                            depositRatio={this.state.depositRatio}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                    <div className={"col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4"}>
                        <div className="col-12 ui-module sticky-bottom-module">
                            <div className="row justify-content-end">
                                {!this.state.deletedAt ? (
                                    <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                        <div className={"d-flex"}>
                                            <div className={""}>
                                                <ConfirmButton
                                                    onModalRender={(m, c) => {
                                                        this.setState({ modal: m }, c)
                                                    }}
                                                    onClick={this.deletePriceList}
                                                    identifier={this.state.identifier}
                                                    className="btn btn-outline-danger mr-2 mb-2"
                                                >
                                                    <Icon value={"trash"} className={"mr-1"} />
                                                    <FormattedMessage id="price_list.edit.delete_btn" defaultMessage="Delete" />
                                                </ConfirmButton>
                                                {this.state.items.length > 0 ? (
                                                    <ActionButton
                                                        className={"btn btn-outline-primary mb-2"}
                                                        onClick={this.openPreview}
                                                    >
                                                        <Icon value={"eye"} className={"mr-1"} />
                                                        <FormattedMessage
                                                            id="price_list.edit.preview_btn"
                                                            defaultMessage="Preview"
                                                        />
                                                    </ActionButton>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </div>
                                        <div className={""}>{actions}</div>
                                    </div>
                                ) : (
                                    <div className="col-12">
                                        <p className="text-align-right text-warning m-0">
                                            <FormattedMessage
                                                id="price_list.archived_info"
                                                defaultMessage="This {priceList} is archived and can't be found in search results."
                                                values={{
                                                    priceList: getPriceListName(this.props.intl)
                                                }}
                                            />
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state, props) => {
    const id = props.match.params.priceListId
    return {
        ...props,
        priceList: getPriceList(state, id)
    }
}
const mapDispatch = {
    fetchPriceList,
    patchPriceList,
    setPricingTableItems,
    setPricingTableGroups,
    setPricingTableGroupItems,
    setPricingTableInitialState,
    fetchPriceLevels,
}

export default connect(mapState, mapDispatch)(injectIntl(PriceListEdit))



// WEBPACK FOOTER //
// ./src/price-list/pricelist.component.jsx